<template>
  <div>
    <div v-if="!isEmpty(quiz)">
      <div v-if="!isEmpty(questions)">
        <SlickList
          lockAxis="y"
          v-model="questions"
          class="panel"
          :useDragHandle="true"
          @sort-end="reorderQuestions"
        >
          <SlickItem
            v-for="(item, index) in questions"
            :index="index"
            :key="index"
            class="box"
            style="margin: 0; border-radius: 0; box-shadow: none; border-left: none; border-right: none; border-bottom: none; padding: 10px 0;"
          >
            <div class="columns is-mobile">
              <div class="column is-narrow">
                <button v-handle class="button">
                  <i class="fa fa-bars"></i>
                </button>
              </div>
              <div class="column is-narrow">
                <span class="tag is-medium">#{{ item.order + 1 }}</span>
              </div>
              <div class="column" :class="{'truncated-text': $device.isMobile}">
                <p>
                  <span v-if="!isEmpty(item.body)">{{ stripHtml(item.body).length > 100 ? stripHtml(item.body).substring(0, 100) + '...' : stripHtml(item.body) || '-' }}</span>
                  <span v-else>-</span>
                </p>
                <p class="has-text-grey" v-if="!isEmpty(item.medias)">
                  <small>
                    <i class="fa fa-paperclip"></i>
                    &nbsp;{{ item.medias.length }} Lampiran
                  </small>
                </p>
              </div>
              <div class="column is-1 has-text-right" v-if="quiz.type == 0">
                <span class="has-text-info">{{ item.score }}</span>
              </div>
              <div class="column is-narrow">
                <div class="buttons">
                  <button
                    @click.prevent="showModalQuestion(item.order)"
                    class="button is-info tooltip"
                    data-tooltip="Ubah"
                    :disabled="quiz.status != 0"
                  >
                    <i class="fa fa-edit"></i>
                  </button>
                  <button
                    class="button is-danger"
                    :disabled="quiz.status != 0"
                    @click.prevent="removeQuestion(item.order)"
                    data-tooltip="Hapus Pertanyaan"
                    v-if="quiz.status != 2"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </SlickItem>
        </SlickList>
      </div>

      <div v-if="isEmpty(questions)">
        <article class="message">
          <div class="message-body has-text-grey">
            <small>Tidak ada pertanyaan.</small>
          </div>
        </article>
      </div>
    </div>

    <div style="margin-top: 10px;">
      <div class="columns is-vcentered">
        <div class="column">
          <button
            id="add_question_button"
            ref="add_question_button"
            class="button is-info is-fullwidth is-marginless is-outlined"
            @click.prevent="showModalQuestion"
            :disabled="quiz.status != 0"
            style="margin-bottom: 10px;"
          >Tambah Pertanyaan</button>
        </div>

        <div class="column">
          <button class="button is-fullwidth is-gapless" @click="import_modal = true" :disabled="quiz.status != 0">
            <span>Import Pertanyaan</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Add New Question -->
    <div
      v-if="!isEmpty(selected_question)"
      class="box has-background-white-bis"
      style="padding: 10px;"
    >
      <form action @submit.prevent="saveQuestion">
        <div class="field">
          <label class="label" for>Pertanyaan ke {{ (selected_question.order + 1) }}</label>
          <div class="control">
            <div class="content">
              <txteditor
                :editText="edit_question_body"
                :onSave="setQuestionDesc"
                :onUpdate="setQuestionDesc"
                :text="selected_question.body"
                contentStyle="max-height: 200px !important; overflow-y: auto;"
              ></txteditor>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">Gambar Tautan</label>
              <div class="control">
                <div class="columns is-multiline is-vcentered">
                  <div
                    class="column is-narrow"
                    style="position: relative;"
                    v-for="(media, key) in selected_question_medias"
                    :key="key"
                  >
                    <a
                      class="has-text-danger has-background-white-bis is-circle"
                      style="position: absolute; right: 4px; top: 4px; z-index: 1;"
                      @click.prevent="removeMedia(media)"
                      v-if="quiz.status != 2"
                    >
                      <span class="icon">
                        <i class="fas fa-times-circle"></i>
                      </span>
                    </a>

                    <div class="is-relative" @mouseenter="hover_image = media.id" @mouseleave="hover_image = null" @click.prevent="">
                      <div class="overlay" v-if="hover_image == media.id">
                        <div class="columns is-vcentered" style="margin: 0; height: 100%;">
                          <div class="column">
                            <button class="button is-text has-text-white" style="background: transparent;" @click.prevent="selected_question_media = media">
                              <span class="icon"><i class="fas fa-eye"></i></span>
                            </button>
                          </div>
                        </div>
                      </div>

                      <figure class="image is-64x64">
                        <img
                          :src="!isEmpty(media.images) && !isEmpty(media.images.thumb) && !isEmpty(media.images.thumb.link) ? media.images.thumb.link : '/assets/img/no-img.png'"
                        />
                      </figure>
                    </div>
                  </div>

                  <div
                    class="column is-narrow"
                    style="position: relative;"
                    v-if="quiz.status != 2 && selected_question_medias.length < 3"
                  >
                    <button
                      class="button is-medium is-info is-outlined"
                      @click.prevent="show_media_library_modal = true"
                    >
                      <span class="icon is-large">
                        <i class="fas fa-paperclip"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="column" v-if="quiz.type == 0">
            <b-field label="Bobot">
              <b-input
                type="number"
                placeholder="e.g: 100"
                min="0"
                :max="question_score_max"
                v-model="selected_question_score"
                required
                validation-message="Silakan isi Bobot pertanyaan"
                @input="(val) => {
                  selected_question_score = val.replace(/^0+/, '');
                }"
              ></b-input>
            </b-field>
          </div>
        </div>

        <div class="field">
          <label class="label">Jawaban</label>
          <div
            v-if="!isEmpty(selected_question.answers)"
            class="control"
            style="margin-bottom: 0px;"
            v-for="(answer, key) in selected_question.answers"
            :key="key"
          >
            <div class="columns is-mobile">
              <div class="column is-1">
                <span class="tag is-medium">{{ keyAlphabet(key) }}</span>
              </div>
              <div class="column">
                <div class="content">
                  <txteditor
                    :editText="true"
                    :onUpdate="(text) => answer.body = text"
                    :text="answer.body"
                    :toolbars="['bold', 'italic', 'strike', 'underline', 'code', 'paragraph', 'bullet_list', 'ordered_list', 'horizontal_rule']"
                    :addons="['image_text']"
                    :showFileTypesInfo="false"
                    contentStyle="max-height: 200px !important; overflow-y: auto;"
                  ></txteditor>
                </div>
              </div>
              <div class="column is-narrow">
                <div class="columns is-mobile is-gapless">
                  <div class="column is-narrow">
                    <a
                      class="button is-text has-text-dark tooltip is-tooltip-left"
                      @click.prevent="setCorrectAnswer(answer)"
                      :class="answer.correct ? 'has-text-info' : ''"
                      :data-tooltip="`Pilih ${keyAlphabet(key)} sebagai Jawaban Benar`"
                    >
                      <b-icon icon="check"></b-icon>
                    </a>
                  </div>
                  <div class="column is-narrow has-text-right" v-if="quiz.status != 2">
                    <button
                      type="button"
                      class="button has-text-danger is-text is-tooltip-left"
                      :class="{'tooltip': key > 1, 'is-disabled': answer.correct}"
                      data-tooltip="Hapus Jawaban"
                      @click.prevent="removeAnswer(key)"
                      :disabled="answer.correct || key <= 1"
                    >
                      <b-icon icon="close"></b-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="control" v-if="isEmpty(selected_question.answers)">
            <article class="box" style="border: 1px dashed #E5E5E5; padding: 10px;">
              <div class="has-text-grey">
                <small>Tidak ada jawaban.</small>
              </div>
            </article>
          </div>
          <!-- </div> -->
        </div>

        <div class="columns">
          <div class="column">
            <button
              v-if="selected_question.answers.length < limit_answers && quiz.status == 0"
              class="button is-text has-text-link"
              @click.prevent="addAnswer"
              :disabled="quiz.status == 2"
            >
              <span class="icon">
                <b-icon icon="plus"></b-icon>
              </span>
              <span>Tambah Jawaban</span>
            </button>
          </div>

          <div class="column is-narrow">
            <div class="columns is-mobile is-gapless">
              <div class="column is-narrow">
                <button type="button" class="button is-text" @click.prevent="cancel">Batal</button>
              </div>

              <div class="column is-narrow">
                <button
                  type="submit"
                  class="button is-primary"
                  :class="{'is-loading': loading_save_question}"
                  :disabled="loading_save_question || quiz.status == 2"
                >Simpan Pertanyaan</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Preview Modal -->
    <b-modal v-if="!isEmpty(selected_question_media) && !isEmpty(selected_question_media.images) && !isEmpty(selected_question_media.images.thumb) && !isEmpty(selected_question_media.images.thumb.link)" :active="true" @close="selected_question_media = null">
      <p class="image is-4by3">
        <img :src="selected_question_media.images.original.link">
      </p>
    </b-modal>

    <!-- Media Library Modal -->
    <b-modal
      :active.sync="show_media_library_modal"
      v-if="!isEmpty(selected_question)"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <form action>
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head has-background-primary">
            <p class="modal-card-title has-text-white">Media Library</p>
          </header>
          <section class="modal-card-body">
            <media-library
              :selected_ids="!isEmpty(selected_question) && !isEmpty(selected_question.media_ids) ? selected_question.media_ids : []"
              :mediaCatcher="mediaCatcher"
              :multiple="true"
              :types="['image']"
              :max="5"
              :onClickCancel="() => show_media_library_modal = false"
            ></media-library>
          </section>
        </div>
      </form>
    </b-modal>

    <!-- Import Modal -->
    <b-modal
      :active.sync="import_modal"
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <div class="box is-boxed">
        <b-message type="is-info" has-icon>
          <div class="content">
            <p>Tips Mudah Import Soal : </p>
            <ol>
              <li>Silakan unduh salah satu
                <b-dropdown aria-role="list">
                  <a slot="trigger">
                    <strong>Contoh Template</strong>
                  </a>

                  <b-dropdown-item
                    aria-role="listitem"
                    @click="downloadExampleImportFile('docx')"
                  >MS Word 2007-2013 (.docx)</b-dropdown-item>
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="downloadExampleImportFile('txt')"
                  >Text File (.txt)</b-dropdown-item>
                </b-dropdown>
                berikut.
              </li>
              <li>Lengkapi pertanyaan Anda sesuai dengan contoh </li>
              <li>Unggah berkas import soal Anda dengan cara drag file ke box / pilih file </li>
              <li>Pastikan berkas yg diupload berupa <strong>.txt</strong> atau <strong>.docx</strong></li>
            </ol>
          </div>
        </b-message>

        <b-field>
          <b-upload
            v-if="isEmpty(import_file)"
            v-model="import_file"
            drag-drop
            style="width: 100%;"
            accept=".docx, .txt, .xlsx"
          >
            <section class="section">
              <div class="content has-text-centered">
                <p>
                  <b-icon icon="upload" size="is-large"></b-icon>
                </p>
                <p style="margin-bottom: 0;">Drop your files here or click to upload</p>
                <p class="help has-text-grey">
                  <small>Maksimal 100MB</small>
                </p>
              </div>
            </section>
          </b-upload>

          <b-tag
            v-if="!isEmpty(import_file)"
            type="is-primary"
            closable
            aria-close-label="Close tag"
            size="is-medium"
            @close="import_file = null"
          >{{ import_file.name }}</b-tag>
        </b-field>

        <div class="is-clearfix">
          <div class="buttons is-pulled-right">
            <button
              class="button is-text"
              style="margin-right: 10px;"
              @click.prevent="import_modal = false"
              :disabled="loading_import"
              :class="{'is-loading': loading_import}"
            >Batal</button>

            <button
              class="button is-info"
              style="margin-right: 10px;"
              @click.prevent="importQuestions"
              :disabled="loading_import"
              :class="{'is-loading': loading_import}"
            >Import</button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { SlickList, SlickItem, HandleDirective } from "vue-slicksort";
import { mapState } from "vuex";
import { QUIZ_QUESTION } from "~/consts";
import MEDIA_MIXIN from "~/mixins/medias";
import QUIZ_MIXIN from "~/mixins/quiz";
import TextEditor from "~/components/TextEditor";

const selected_question = {
  order: 0,
  body: "",
  score: 0,
  answers: [
    { value: 0, body: "", correct: true },
    { value: 1, body: "" },
    { value: 2, body: "" }
  ],
  media_ids: [],
  correct_answer: 0
};

export default {
  mixins: [MEDIA_MIXIN, QUIZ_MIXIN],

  props: {
    quiz: {
      type: Object,
      default: function() {
        return {
          postId: null,
          title: "",
          groupId: null,
          questions: []
        };
      }
    },
    onSaveQuestion: {
      type: Function,
      default: () => {}
    },
    onSelectedQuestion: {
      type: Function,
      default: () => {}
    }
  },

  components: {
    SlickItem,
    SlickList,
    txteditor: TextEditor
  },

  directives: { handle: HandleDirective },

  computed: {
    ...mapState({
      loading_save_quiz: state => state.quizes.loading_save_quiz
    }),
    selected_question_score: {
      get() {
        return this.selected_question.score;
      },
      set(val) {
        if (val > this.question_score_max) {
          toast.danger(`Bobot tidak dapat lebih dari ${this.question_score_max}`);
        } else {
          this.selected_question.score = val;
        }
      }
    }
  },

  watch: {
    show_modal(val) {
      if (!val) {
        this.selected_question_medias = [];
        this.show_modal = false;
      }
    },
    selected_question(val) {
      this.onSelectedQuestion(val);
    },
  },

  data() {
    return {
      loading_save_question: false,
      loading_get_questions: false,
      selected_question: null,
      edit_question: true,
      edit_question_body: true,
      show_modal: false,
      media_ext_s: ["jpg", "jpeg", "png", "gif"],
      questions: [],
      selected_question_medias: [],
      limit_answers: 5,
      import_modal: false,
      import_file: null,
      loading_import: false,
      selected_question_media: null,
      hover_image: null,
      question_score_max: 1000
    };
  },

  methods: {
    setMedias(medias) {
      this.selected_question["media_ids"] = collect(medias)
        .pluck("id")
        .toArray();
      this.selected_question_medias = medias;
    },
    setQuestionDesc(text) {
      this.selected_question.body = text;
    },
    showModalQuestion(order) {
      const vm = this;

      this.cancel();

      Vue.nextTick(() => {
        if (typeof order == "object") {
          this.resetSelectedQuestion();
          this.selected_question.order = this.questions.length;
        } else {
          let item = collect(this.questions)
            .where("order", "==", order)
            .first();
          if (this.isEmpty(item["media_ids"])) {
            item["media_ids"] = collect(item.medias)
              .pluck("id")
              .toArray();
          }

          const selected_question = _.cloneDeep(item);
          selected_question.answers = selected_question.answers.map(ans => {
            if (selected_question.correct_answer == ans.value) {
              ans.correct = true;
            }

            return ans;
          })
          this.selected_question = selected_question;
          this.getMedias(item.media_ids);
          this.edit_question = true;
        }

        this.show_modal = true;
        this.edit_question_body = true;
        this.scrollToBox();
      });
    },
    saveQuestion() {
      const vm = this;

      //    Prevent execute when loading is run
      if (vm.loading_save_question) {
        return;
      }

      //    Validation
      if (vm.quiz.type == 0 && vm.selected_question.score <= 0) {
        toast.danger("Silakan isi Bobot pertanyaan");
        return;
      }

      vm.loading_save_question = true;

      Vue.nextTick(() => {
        const isContinue = this.selected_question.answers.every((answer, aindex) => {
          if (this.isEmpty(this.strip_tags(answer.body))) {
            toast.danger(`Jawaban ${this.keyAlphabet(aindex)} harus diisi`);
            return false;
          }

          return true
        });
        if (!isContinue) {
          vm.loading_save_question = false;
          return;
        }
        let correct_answer = collect(this.selected_question.answers).filter(ans => ans.correct).first();
        if (this.isEmpty(correct_answer)) {
          vm.loading_save_question = false;
          toast.danger("Silakan pilih jawaban yang benar")
          return;
        }
        let selected_question = _.cloneDeep(this.selected_question);
        selected_question.answers = selected_question.answers.map(ans => {
          delete ans.correct;
          return ans;
        });
        let questions = _.cloneDeep(this.questions);
        selected_question.correct_answer = correct_answer.value;

        // Update
        if (
          !this.isEmpty(
            collect(questions)
              .where("order", "==", selected_question.order)
              .first()
          )
        ) {
          questions = collect(questions)
            .map(question => {
              if (question.order == selected_question.order) {
                return selected_question;
              }

              return question;
            })
            .toArray();

          // ADD NEW
        } else {
          questions.push(selected_question);
        }

        this.setQuestions(questions);
        this.selected_question = null;
        this.show_modal = false;
        this.loading_save_question = false;
      });
    },
    resetSelectedQuestion() {
      this.selected_question = _.cloneDeep(selected_question);
    },
    cancel() {
      this.selected_question = null;
      this.scrollToBox();
    },
    addAnswer() {
      let answers = collect(this.selected_question.answers);

      if (answers.count() < this.limit_answers) {
        this.selected_question.answers = answers
          .merge([{ value: answers.count(), body: "" }])
          .toArray();
      }
    },
    scrollToBox() {
      document.querySelector("#add_question_button").scrollIntoView();
    },
    removeQuestion(order) {
      const vm = this;

      vm.$buefy.dialog.confirm({
        title: "Konfirmasi",
        message: "Apakah anda yakin akan menghapus pertanyaan ini?",
        confirmText: "Ya",
        cancelText: "Tidak",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.questions = collect(this.questions)
              .filter(question => question.order != order)
              .toArray()

          this.reorderQuestions();
        }
      });
    },
    removeAnswer(key) {
      const vm = this;

      if (vm.selected_question.answers.length <= 2) {
        toast.danger("Jawaban minimal 2 pilihan");
        return;
      }

      let answers = collect(vm.selected_question.answers);
      const answer = answers.filter((a, k) => key == k).first();

      if (this.isEmpty(answer)) {
        return;
      } else {
        if (answer.correct) {
          toast.danger(`Jawaban tidak dapat dihapus karena sebagai "Jawaban Benar"`);
          return;
        }
      }

      vm.$buefy.dialog.confirm({
        title: "Konfirmasi",
        message: "Apakah anda yakin akan menghapus jawaban ini?",
        confirmText: "Ya",
        cancelText: "Tidak",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.selected_question.answers = answers.filter((a, k) => {
            if (k != key) {
              return true;
            }
          }).map((a, k) => {
            a.value = k;
            return a;
          }).toArray();
          let correct_answer = collect(vm.selected_question.answers).filter(a => a.correct).first();
          vm.selected_question.correct_answer = correct_answer.value
        }
      });
    },
    setQuestions(questions) {
      this.questions = questions;

      this.onSaveQuestion(questions);
    },
    reorderQuestions() {
      const vm = this;

      Vue.nextTick(() => {
        this.setQuestions(
          collect(this.questions)
            .map((q, key) => {
              q["order"] = key;
              return q;
            })
            .toArray()
        );
      });
    },
    mediaCatcher(medias) {
      medias = collect(medias)
        .take(3)
        .toArray();

      let media_ids = collect(medias)
        .pluck("id")
        .unique()
        .toArray();
      this.getMedias(media_ids);

      this.show_media_library_modal = false;
    },
    removeMedia(media) {
      this.selected_question_medias = collect(this.selected_question_medias)
        .filter(m => {
          return m.id != media.id;
        })
        .toArray();

      this.selected_question["media_ids"] = collect(
        this.selected_question["media_ids"]
      )
        .filter(m => {
          return m != media.id;
        })
        .toArray();

      if (!this.isEmpty(this.selected_question["deleted_media_ids"])) {
        this.selected_question["deleted_media_ids"].push(media.id);
      } else {
        this.selected_question["deleted_media_ids"] = [media.id];
      }
    },
    importQuestions() {
      const vm = this;
      var formData = new FormData();

      if (!this.isEmpty(this.import_file)) {
        formData.append("file", this.import_file);
      } else {
        this.$buefy.toast.open({
          message: "Berkas tidak valid",
          type: "is-danger",
          duration: 5000
        });
        vm.file = null;
        return;
      }

      vm.loading_import = true;

      let token = this.$route.query.t;
      token = this.isEmpty(token) ? this.$cookies.get('token') : token;

      if (token) {
        let no_need_encode = false;
        try {
          no_need_encode = helpers.parseJwt(token)
          no_need_encode = !helpers.isEmpty(no_need_encode) && !helpers.isEmpty(no_need_encode.username) && !helpers.isEmpty(no_need_encode.appid)
        } catch (e) {
        }

        token = no_need_encode ? token : helpers.encodeToken(token)
      }

      axios
        .post(`${process.env.API_URL}${QUIZ_QUESTION.EXTRACT}`, formData, {
          headers: {
            "Content-type": "multipart/form-data",
            'Authorization': `Bearer ${token}`
          },
          onUploadProgress: function(progressEvent) {
            var percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );

            vm.progress_upload = percentCompleted;
          }
        })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            let questions = vm.questions.concat(
              this.transformKeysTo(data.data)
            );
            vm.questions = !this.isEmpty(questions) ? questions : [];
            vm.reorderQuestions();
          } else {
            toast.danger(data.applicationSystem.message);
          }

          vm.loading_import = false;
          vm.import_modal = false;
          vm.import_file = null;
        })
        .catch(() => {
          toast.danger("Berkas tidak sesuai");
          vm.loading_import = false;
          vm.import_modal = false;
          vm.import_file = null;
        });
    },
    setCorrectAnswer(answer) {
      this.selected_question.answers = this.selected_question.answers.map(ans => {
        delete ans.correct;

        return ans;
      });
      answer.correct = true;
    }
  }
};
</script>

<style scoped>
.card-content {
  padding: 10px;
}
</style>
